import {ApiError} from "./http";
import {PresignedUrl} from "./models";

// PUTs a file straight to S3 through a pre-signed URL. XMLHttpRequest rather than fetch, for the progress (0–1).
export function uploadToPresignedUrl(target: PresignedUrl, file: Blob, onProgress?: (fraction: number) => void): Promise<void> {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open('PUT', target.url);
        // Must match the Content-Type the URL was signed with.
        request.setRequestHeader('Content-Type', target.contentType ?? 'application/octet-stream');
        request.upload.onprogress = e => {
            if (e.lengthComputable) {
                onProgress?.(e.loaded / e.total);
            }
        };
        request.onload = () => request.status >= 200 && request.status < 300 ? resolve() : reject(new ApiError(request.status));
        request.onerror = () => reject(new ApiError(0));
        request.send(file);
    });
}
